<button [disabled]="!sortable" [ngClass]="{'header-cell': true, 'sortable': !!sortable}" (click)="onClick()">
  <span>{{ text }}</span>
  <div>
    <ng-content *ngIf="tooltip">
      <app-tooltip-icon [text]="tooltip" class="tooltip"></app-tooltip-icon>
    </ng-content>
  </div>
  <ng-content *ngIf="sortable">
    <img [ngClass]="['sort-arrow', this.sort.direction]" [src]="'svg/sort-arrow.svg' | assetVersion">
  </ng-content>
</button>